import { ArrowForwardIosOutlined, Cancel, Search, TurnLeft } from '@mui/icons-material';
import { Drawer, Tab, Tabs, Paper, FormControl, OutlinedInput, InputAdornment, IconButton, TextField, Box, Typography, Link, Dialog } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from 'react'
import defaultImg from "../../assets/svg/defultImage.svg"
import "./OtherServices.css"
import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { DataGrid } from '@mui/x-data-grid';
import noData from "../../assets/svg/Emptyfile1.svg"
import { Form } from 'react-bootstrap';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import { newHost } from '../../pages/Categories/CategoryProfile';
import { newImageUrl } from '../../pages/Manufacturers/ManufactureProfile';

export const ReadMoreChars = ({ text, maxChars = 120 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > maxChars;

  return (
    <Typography
      variant="body1"
      className=""
        sx={{
    lineHeight: 1.6,
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
  }}
    >
      {expanded || !isLong
        ? text
        : `${text.slice(0, maxChars)}...`}

      {isLong && (
        <Link
          component="button"
          underline="none"
          onClick={() => setExpanded(!expanded)}
          sx={{ ml: 1, fontSize: 13, fontWeight: 800,color:"#000000" }}
        >
          {expanded ? "Read less" : "Read more"}
        </Link>
      )}
    </Typography>
  );
};

const OtherServices = () => {
  
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;
  // Header
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [filteredRequests, setFilteredRequests] = useState([]);
  
  // Request Modal

  const [requestShow, setRequestShow] = useState(false);

  const [requestDetails, setRequestDetails] = useState({})

const handleRequestShow = (row) => {
  setRequestDetails(row);

  const draft = localStorage.getItem(getDraftKey(row.id));

  if (draft) {
    const parsedDraft = JSON.parse(draft);

    setServices(parsedDraft.services);

setExpireDate(
  parsedDraft.expireDate
    ? dayjs(parsedDraft.expireDate)
    : null
);

  } else {
    const servicesWithUI = row?.services.map(service => ({
      ...service,
      ui: {
        isAccepted: false,
        isRejected: false,
        price: "",
        notes: "",
        estimated_time: "",
        rejectReason: ""
      }
    }));

    setServices(servicesWithUI);
    setExpireDate(null);
  }

  setRequestShow(true);
};



  const handleRequestClose = () => {
    setRequestShow(false)
  }

  //  Accept & Reject  

  const handleAccept = (id) => {
    setServices(prev =>
      prev.map(s =>
        s.id == id
          ? { ...s, ui: { ...s.ui, isAccepted: true, isRejected: false } }
          : s
      )
    );
  };

  const handleReject = (id) => {
    setServices(prev =>
      prev.map(s =>
        s.id === id
          ? { ...s, ui: { ...s.ui, isAccepted: false, isRejected: true } }
          : s
      )
    );
  };

  const handleReset = (id) => {
    setServices(prev =>
      prev.map(s =>
        s.id == id
          ? {
            ...s,
            ui: {
              isAccepted: false,
              isRejected: false,
              price: "",
              notes: "",
              rejectReason: ""
            }
          }
          : s
      )
    );
  };



  // Handle services Request 

  const [userRequests, setUserRequests] = useState([]);
  const [services, setServices] = useState([]);
  const [requestStatuses, setRequestStatuses] = useState([]);

  const getUserRequests = async () => {
    try {
      const response = await axios.get(`${newHost}portal/door_step_request_others`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }

      )
      console.log(response);


      setUserRequests(response.data.data.other_requests);
    } catch (error) {
      console.log(error);

    }
  }
  // submit services
  const submitServices = async () => {
    
    const formData = new FormData();

    services.forEach((service, index) => {
      if (!service.ui.isAccepted && !service.ui.isRejected) return;

      formData.append(`services[${index}][id]`, service.id);
    
      formData.append(
        `services[${index}][action]`,
        service.ui.isAccepted ? "accepted" : "rejected"
      );

      if (service.ui.isAccepted) {
       formData.append(
      "expire_date", expireDate ? dayjs(expireDate).format("YYYY-MM-DD HH:mm:ss") : ""
    );
        formData.append(`services[${index}][price]`, service.ui.price);
        formData.append(`services[${index}][estbn_notes]`, service.ui.notes);
        formData.append(`services[${index}][estimated_time]`, service.ui.estimated_time);
      }

      if (service.ui.isRejected) {
        formData.append(
          `services[${index}][reject_reason]`,
          service.ui.rejectReason
        );
      }
    });

    try {
      const response = await axios.post(`${newHost}portal/door_step_request_others/services/${requestDetails.id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      localStorage.removeItem(
       getDraftKey(requestDetails.id)
         );

      toast.success(response.data.data.message)
      handleRequestClose()
      getUserRequests()
      getRequestStatuses()
    } catch (error) {
      toast.error(error.response.data.message)
    }

  };
  // get Statuses
  const getRequestStatuses = async () => {
    try {
      const response = await axios.get(`${newHost}portal/door_step_request_others/statuses`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }

      )

      setRequestStatuses(response.data.data.statuses);

    } catch (error) {
      console.log(error);

    }
  }
  const [selectedTab, setSelectedTab] = useState("all");

  // paginations functions
  const [page, setPage] = useState(0);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });




  // table columns
  const columns = [
    {
      field: "id",
      headerName: "Request ID",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <strong>{`# ${params.row.id}`}</strong>
      ),
    },
    {
      field: "client",
      headerName: "Client Name",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <div className="d-flex gap-2 align-items-center justify-content-center">
          <img
            src={
              params.row?.door_step_request?.user?.profile_photo_path
                ? `${newImageUrl}${params.row?.door_step_request.user.profile_photo_path}`
                : defaultImg
            }
            width={30}
            height={30}
            style={{ borderRadius: "50%" }}
          />
          <span>{params.row?.door_step_request?.user?.name}</span>
        </div>
      ),
    },
    {
      field: "car",
      headerName: "Car Model",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) =>
        params.row?.door_step_request?.user?.user_vehicles?.[0]?.name,
    },
    {
      field: "phone",
      headerName: "Mobile Number",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) =>
        params.row?.door_step_request?.user?.phone_number,
    },
    {
      field: "services",
      headerName: "Services",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) =>
        `${params.row?.services_count} services`,
    },
    {
      field: "created_at",
      headerName: "Date",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) =>
        new Date(params.row?.created_at).toLocaleDateString(),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => (
        <div className="d-flex gap-2 align-items-center justify-content-center">
          <img
            src={
              params.row?.status?.image
                ? `${newImageUrl}${params.row.status.image}`
                : defaultImg
            }
            width={20}
          />
          <span>{params.row?.status?.name}</span>
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.9,
      minWidth: 120,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          disableRipple
          size="small"
          onClick={(e) => {handleRequestShow(params.row)
            e.stopPropagation()
          }}
        >
          <ArrowForwardIosOutlined fontSize="small" />
        </IconButton>
      ),
    },
  ];



  useEffect(() => {
    getUserRequests();
  }, [selectedTab, searchQuery, filterDate, page]);


  useEffect(() => {
    getRequestStatuses()
  }, [])

  useEffect(() => {
    let data = [...userRequests];

    if (selectedTab !== "all") {
      data = data.filter(
        (item) => item.status?.id == selectedTab
      );
    }

    if (filterDate) {
      data = data.filter((item) => {
        const itemDate = new Date(item.created_at)
          .toISOString()
          .split("T")[0];
        return itemDate === filterDate;
      });
    }

    if (searchQuery.trim() !== "") {
      const search = searchQuery.toLowerCase();
      data = data.filter(
        (item) =>
          item.id.toString().includes(search) ||
          item.door_step_request?.user?.name
            ?.toLowerCase()
            .includes(search)
      );
    }

    setFilteredRequests(data);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }, [userRequests, selectedTab, searchQuery, filterDate]);


  // Handle request status conditions
  const totalPrice = services.reduce((sum, service) => {
    if (service.ui?.isAccepted && service.ui.price) {
      return sum + Number(service.ui.price);
    }
    return sum;
  }, 0);
const acceptedCount = services.filter(s => s.ui.isAccepted + s.ui.isRejected).length ;
 
const [expireDate, setExpireDate] = useState(null);
const statusName = requestDetails.status?.name;

const isPending = statusName === "pending";
const isCancelled = statusName === "cancelled";
const isExpired = statusName === "expired";

const acceptedWithPriceCount = services.filter(
  s => s.ui.isAccepted && Number(s.ui.price) > 0
).length;


const shouldShowPriceSection = (isPending && acceptedWithPriceCount > 0) 
 




const [openImage, setOpenImage] = useState(false);
const [selectedImage, setSelectedImage] = useState(null);

const getDraftKey = (requestId) =>
  `doorstep_request_draft_${requestId}`;
const saveDraft = () => {
  if (!requestDetails?.id) return;

  const draftData = {
    services,
  expireDate: expireDate
    ? dayjs(expireDate).toISOString()
    : null
  };

  localStorage.setItem(
    getDraftKey(requestDetails.id),
    JSON.stringify(draftData)
  );

  toast.success("Draft saved locally");
};
useEffect(() => {
  if (!requestDetails?.id) return;

  const timeout = setTimeout(() => {
    const draftData = {
      services,
      expireDate,
    };

    localStorage.setItem(
      getDraftKey(requestDetails.id),
      JSON.stringify(draftData)
    );
  }, 800);

  return () => clearTimeout(timeout);
}, [services, expireDate]);


  return (
    <>
      {/* Request Side */}
      <Drawer
        anchor="right"
        open={requestShow}
        onClose={handleRequestClose}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 13,
            borderBottomLeftRadius: 13,
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            width: { xs: "100vw", sm: 700 },
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",


          }}
        >
          {/*HEADER*/}
          <Box
            sx={{
              p: 2,
              borderBottom: "1px solid #eee",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >

            <div className="d-flex gap-3 align-items-center">
              <Typography
                variant="h6"
                className="text-black d-flex gap-3 align-items-center"
              >
                Request #{requestDetails.id}
              </Typography>
              <div  className="d-flex justify-content-center align-items-center gap-1 px-3 rounded-4">
                <div className='' style={{ width: "20px", height: "", }}>
                  <img
                    src={requestDetails.status?.image ? `${newImageUrl}${requestDetails.status?.image}` : defaultImg}
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                <div
                  style={{
                    backgroundColor: "",
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                  className='main-text-color'
                >
                  {requestDetails.status?.name}
                </div>
              </div>

            </div>
            <IconButton onClick={handleRequestClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              flex: 1,
              px: 0,
            }}
          >

            {/* Request Header */}
                <div className="border-bottom my-1">
                  <div className='py-2'>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="mx-4">
                          <h6 style={{
                            fontSize: "14px"
                          }} className="main-text-color ">Client Name</h6>
                          <div className="d-flex gap-2 align-items-center">
                            <img style={{ width: "30px", height: "30px" }} src={requestDetails?.door_step_request?.user?.profile_photo_path ? `${newImageUrl}${requestDetails?.door_step_request?.user?.profile_photo_path}` : defaultImg} alt="" className={`${requestDetails?.door_step_request?.user?.profile_photo_path ? "rounded-5" : ""}`} />
                            <h6 className="m-0 fw-semibold">
                              {requestDetails.door_step_request?.user?.name}
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <h6 style={{
                          fontSize: "14px"
                        }} className="main-text-color ">Mobile Number</h6>
                        <h6 className="my-3">{requestDetails.door_step_request?.user?.phone_number}</h6>
                      </div>
                    </div>
                    <div className="row my-2">
                      <div className="col-12 col-md-6">
                        <div className="mx-4">
                          <h6 style={{
                            fontSize: "14px"
                          }} className="main-text-color ">Time</h6>
                          <h6 className="my-3">{new Date(requestDetails?.created_at).toLocaleDateString()}</h6>

                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <h6 style={{
                          fontSize: "14px"
                        }} className="main-text-color ">Services Number</h6>
                        <h6 className="my-3">{`${requestDetails.services_count} services`}</h6>
                      </div>
                    </div>
                    <div className="row my-2">
                      <div className="col-12 col-md-6">
                        <div className="w-100 mx-4">
                          <h6 style={{
                            fontSize: "14px"
                          }} className="main-text-color ">Expiry Date
                          
                          </h6>
                          {isPending?   <LocalizationProvider
          
                            dateAdapter={AdapterDayjs}>
                            <DemoContainer
          
                              components={["DateTimePicker'"]}
          
                            >
                              <DateTimePicker
                                  sx={{ width: "25%" }}
                                className="m-0"
                                slotProps={{
                                  textField: { size: "small", placeholder: "48 h" }
                                }}
                                value={expireDate}
                                onChange={(date) => setExpireDate(date)}
                              />

                                                  
                            </DemoContainer>
                          </LocalizationProvider>  : requestDetails.expire_date? <h6 className="my-3">{`${new Date (requestDetails.expire_date).toLocaleDateString()}, ${new Date(requestDetails.expire_date).toLocaleTimeString()}`}</h6> : <><span>-</span></> }
                    
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <h6 style={{
                          fontSize: "14px"
                        }} className="main-text-color ">Estimated Time</h6>
                        <h6 className="my-3">{`${requestDetails.total_estimated_time} min`}</h6>
                      </div>
                    </div>
                  </div>
                </div>

            {/* Requests services */}
            {isPending? 
            <>
                 {services.map((service, index) => (
              <div key={service.id} className="my-2 p-3">

                <h6 className="main-text-color">
                  Service {index + 1}
                </h6>

                <div className="mt-3 p-3 rounded-2"
                  style={{ backgroundColor: "#F8F8F899", border: "1px solid #C6C6C633" }}
                >

                  <div className="d-flex gap-2">

                    <button
                      onClick={() => handleAccept(service.id)}
                      className={`btn-accept ${service.ui.isAccepted || service.ui.isRejected ? "d-none" : ""
                        }`}
                    >
                      Accept
                    </button>

                    <button
                      onClick={() => handleReject(service.id)}
                      className={`btn-reject ${service.ui.isAccepted ? "d-none" : ""
                        }`}
                    >
                      Reject
                    </button>

                    {service.ui.isAccepted && (
                      <>
                        <button onClick={() => handleReset(service.id)}><TurnLeft sx={{ color: "#696969", fontWeight: "300" }} /></button>
                        <button className="btn-accept">Accept</button>
                      </>
                    )}

                    {service.ui.isRejected && (
                      <button onClick={() => handleReset(service.id)}><TurnLeft sx={{ color: "#696969", fontWeight: "300" }} /></button>
                    )}
                  </div>

                  {/* DETAILS */}
                  <div className="d-flex justify-content-end">
                    <div className="text-end">
                      <h6 className="fw-bold">{service.title}</h6>
                     <ReadMoreChars text={service.description} maxChars={150} />
                        <div className="d-flex gap-3 align-items-center justify-content-end my-2 w-100">
                          {service.images.length > 0
                            ? service.images.map((serviceImg, index) => (
                                <div
                                  key={index}
                                  style={{ width: "130px", height: "85px", backgroundColor: "#FFFFFF" }}
                                  className="rounded-2 p-2 border"
                                >
                                  <img
                                    className="w-100 h-100"
                                    src={serviceImg?.full_image_url}
                                    alt=""
                                    style={{ cursor: "pointer", objectFit: "fill" }}
                                    onClick={() => {
                                      setSelectedImage(serviceImg?.full_image_url);
                                      setOpenImage(true);
                                    }}
                                  />
                                </div>
                              ))
                            : (
                              <div
                                style={{ width: "130px", height: "85px", backgroundColor: "#FFFFFF" }}
                                className="rounded-2 p-2 border"
                              >
                                <img
                                  className="w-100 h-100"
                                  src={defaultImg}
                                  alt=""
                                  style={{  objectFit: "fill" }}
                            
                                />
                              </div>
                            )}
                        </div>
                        <Dialog
                          open={openImage}
                          onClose={() => setOpenImage(false)}
                          fullScreen
                          PaperProps={{
                            sx: {
                              backgroundColor: "rgba(0,0,0,0.95)",
                            }
                          }}
                        >
                          <IconButton
                            onClick={() => setOpenImage(false)}
                            sx={{
                              position: "absolute",
                              top: 16,
                              right: 16,
                              color: "#fff",
                              zIndex: 10,
                            }}
                          >
                            <CloseIcon fontSize="large" />
                          </IconButton>

                          <Box
                            sx={{
                              width: "100vw",
                              height: "100vh",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={selectedImage}
                              alt=""
                              style={{
                                maxWidth: "100%",
                                maxHeight: "500px",
                                objectFit: "contain",
                              }}
                            />
                          </Box>
                        </Dialog>


           


                    </div>

                  </div>


                  {/* ACCEPT */}
                  {service.ui.isAccepted && (
                    <>
                      <TextField
                        type="number"
                        size="small"
                        className="w-100 my-1"
                        placeholder="Service price"
                        value={service.ui.price}
                        onChange={(e) =>
                          setServices(prev =>
                            prev.map(s =>
                              s.id === service.id
                                ? { ...s, ui: { ...s.ui, price: e.target.value } }
                                : s
                            )
                          )
                        }
                      />

                      <textarea
                        className="w-100 my-1"
                        style={{ padding: 10, borderRadius: 5, border: "solid 2px #D8D8D8", }}
                        rows={3}
                        placeholder="Notes"
                        value={service.ui.notes}
                        onChange={(e) =>
                          setServices(prev =>
                            prev.map(s =>
                              s.id == service.id
                                ? { ...s, ui: { ...s.ui, notes: e.target.value } }
                                : s
                            )
                          )
                        }
                      />
                    <Form.Group className="mb-3">
              <Form.Control
                type="number"
                min="0"
                size='sm'
                placeholder="Add estimated time in minutes"
                  value={service.ui.estimated_time}
                        onChange={(e) =>
                          setServices(prev =>
                            prev.map(s =>
                              s.id == service.id
                                ? { ...s, ui: { ...s.ui, estimated_time: e.target.value } }
                                : s
                            )
                          )
                        }
                className="add-service-input"
   
              />
            </Form.Group>
                    </>
                  )}

                  {/* REJECT */}
                  {service.ui.isRejected && (
                    <textarea
                      style={{ padding: 10, borderRadius: 5, border: "solid 2px #D8D8D8", }}
                      className="w-100 my-1"
                      rows={3}
                      placeholder="Reject reason"
                      value={service.ui.rejectReason}
                      onChange={(e) =>
                        setServices(prev =>
                          prev.map(s =>
                            s.id === service.id
                              ? { ...s, ui: { ...s.ui, rejectReason: e.target.value } }
                              : s
                          )
                        )
                      }
                    />
                  )}
                </div>
              </div>
            ))}

            
            </> 
            : <>
            {
             services.map((service, index)=>
            <div key={service.id} className="my-2 p-3">
              <h6 className="main-text-color">
                              Service {index + 1}
                            </h6>
            <div className="my-2 p-3 rounded-2"
            style={{ backgroundColor: "#F8F8F899", border: "1px solid #C6C6C633" }}
            >

              <div className="mt-3">
                {service.status == "rejected_by_user" ? <>
                <span className="btn-reject px-4">User Rejected <Cancel  sx={{color:"#A80101",}}/></span>
                
                </> : service.status == "rejected_by_admin" ? <>
                <span className="btn-reject px-4">Admin Rejected <Cancel  sx={{color:"#A80101",}}/> </span>
                </> : service.status == "accepted_by_user" ? <>
                
                <span className="btn-accept px-4">User Accepted <CheckCircleIcon sx={{color:"#3FBEAC"}} />  </span>
                </> : service.status == "accepted_by_admin" ?  <> <span className="btn-accept px-4"> Admin Accepted <CheckCircleIcon sx={{color:"#3FBEAC"}} /></span></>
                
              : null }
                
              </div>
              {/* DETAILS */}
                              <div className="d-flex justify-content-end">
                                <div className="text-end">
                                  <h6 className="fw-bold">{service.title}</h6>
                                  <ReadMoreChars text={service.description} maxChars={150} />

                                  <div className="d-flex gap-3 align-items-center justify-content-end my-2 w-100">
                        
                                    {service.images.length > 0
              ? service.images.map((serviceImg, index) => (
                  <div
                    key={index}
                    style={{
                      width: "130px",
                      height: "85px",
                      backgroundColor: "#FFFFFF",
                      cursor: "pointer",
                    }}
                    className="rounded-2 p-2 border"
                    onClick={() => {
                      setSelectedImage(serviceImg?.full_image_url);
                      setOpenImage(true);
                    }}
                  >
                    <img
                      className="w-100 h-100"
                      src={serviceImg?.full_image_url}
                      alt=""
                      style={{
                        objectFit: "fill",
                        borderRadius: "6px",
                      }}
                    />
                  </div>
                ))
              : (
                <div
                  style={{
                    width: "130px",
                    height: "85px",
                    backgroundColor: "#FFFFFF",
                  }}
                  className="rounded-2 p-2 border"
          
                >
                  <img
                    className="w-100 h-100"
                    src={defaultImg}
                    alt=""
                    style={{
                      objectFit: "fill",
                      borderRadius: "6px",
                    }}
                  />
                </div>
              )}
            <Dialog
              open={openImage}
              onClose={() => setOpenImage(false)}
              fullScreen
              PaperProps={{
                sx: { backgroundColor: "rgba(0,0,0,0.95)" }
              }}
            >
              <IconButton
                onClick={() => setOpenImage(false)}
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  color: "#fff",
                  zIndex: 10,
                }}
              >
                <CloseIcon fontSize="large" />
              </IconButton>

              <Box
                sx={{
                  width: "100vw",
                  height: "100vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={selectedImage}
                  alt=""
                  style={{
                    maxWidth: "100%",
                    maxHeight: "500px",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Dialog>

                                  </div>


                                </div>

                              </div>
                        <div className="my-2">
                        
                          <div className="">
                            <h6 className="main-text-color label-size">Service Price <span className='text-danger'>*</span></h6>
                            <p  className="fw-semibold">{service.price? `${Number(service.price)?.toLocaleString("en-US")} L.E ` : "-"}</p>
                          </div>
                          
                        
                          <div className="">
                            <h6 className="main-text-color label-size">Estimated Time<span className='text-danger'>*</span></h6>
                            <p className="fw-semibold">{`${service.estimated_time} min`}</p>
                          </div>
                          <div className="">
                            <h6 className="main-text-color label-size">ESTBN Notes<span className='text-danger'>*</span></h6>
                            <div style={{direction:"rtl"}} className="">
                              <ReadMoreChars text={service.estbn_notes? `${service.estbn_notes}` : "-"} maxChars={150} />


                            </div>
                          </div>
                          <div className="">
                            <h6 className="main-text-color label-size">Reject Reason<span className='text-danger'>*</span></h6>
                            <div style={{direction:"rtl"}} className="">
                              <ReadMoreChars text={service.reject_reason? `${service.reject_reason}` : "-"} maxChars={150} />
                            </div>
                          </div>
                  
                        </div>
            </div>
                        </div>
            
              )
            }
           
            
            </>
            
            }
       
          </Box>

          {/* Submit Requests */}

         {isCancelled ? (
            <div className="fixed-footer-wrapper">
 <div className="fixed-footer-cancel">
                <div className="d-flex align-items-center gap-2">
                  <InfoIcon sx={{ color: "#A80101" }} />
                  <h6 className="m-0">Reason for Rejection:</h6>
                </div>

                <div className='my-2'>
                  <ReadMoreChars
                    text={
                      requestDetails.reject_reason
                        ? requestDetails.reject_reason
                        : "No comment"
                    }
                    maxChars={150}
                  />
                </div>
              </div>
              <div className="fixed-footer-total-price">
              {!isPending && 
                  
                  <div
              style={{ backgroundColor: "#EFEFEF" }}
              className="my-2 p-3 rounded-2"
            > 
            <div className="d-flex align-items-center justify-content-between pb-2 ">
              <h6 className="m-0">Total Services Price:</h6>

          <h6 className="fw-bold m-0">
              { `${Number(requestDetails.total_services_price)?.toLocaleString("en-US")} L.E`}
            </h6>
            </div>
            <div className="d-flex align-items-center justify-content-between py-2 ">
              <h6 className="fw-bold m-0">Customer Final Cost:</h6>

              <h6 className="fw-bold m-0">
              { `${Number(requestDetails.total_price)?.toLocaleString("en-US")} L.E`}

            </h6>
            </div>
            </div>}
              </div>

             

            </div>
                ) : isExpired ? <>
                <div className="fixed-footer-wrapper">
                    <div className="fixed-footer-expire">
                      <div className="d-flex align-items-center gap-2">
                        <InfoIcon sx={{ color: "#FEB91E" }} />
                        <h6 className="m-0">Request expired. The expiration date has passed and prices have changed.</h6>
                      </div>

                    
                    </div>
                  <div className="fixed-footer-total-price">
                    {!isPending && 
                        
                        <div
                    style={{ backgroundColor: "#EFEFEF" }}
                    className="my-2 p-3 rounded-2"
                  > 
                  <div className="d-flex align-items-center justify-content-between pb-2 ">
                    <h6 className="m-0">Total Services Price:</h6>

                <h6 className="fw-bold m-0">
                    { `${Number(requestDetails.total_services_price)?.toLocaleString("en-US")} L.E`}
                  </h6>
                  </div>
                  <div className="d-flex align-items-center justify-content-between py-2 ">
                    <h6 className="fw-bold m-0">Customer Final Cost:</h6>

                    <h6 className="fw-bold m-0">
                    { `${Number(requestDetails.total_price)?.toLocaleString("en-US")} L.E`}

                  </h6>
                  </div>
                  </div>}
                    </div>
              
                    </div>   
                  </> :  (
              <div className="mt-3 flex-column p-3 fixed-footer">
                  {shouldShowPriceSection &&
              <div
                style={{ backgroundColor: "#EFEFEF" }}
                className="my-2 d-flex align-items-center justify-content-between p-3 rounded-2"
              > 
                <h6 className="m-0">Total Services Price:</h6>

            <h6 className="fw-bold m-0">
                  {isPending
                  ? `${totalPrice.toLocaleString("en-US")} L.E`
                  : `${Number(requestDetails.total_price)?.toLocaleString("en-US")} L.E`}
              </h6>
              </div>
              
            }
                {!isPending && 
                    
                    <div
                style={{ backgroundColor: "#EFEFEF" }}
                className="my-2 p-3 rounded-2"
              > 
              <div className="d-flex align-items-center justify-content-between pb-2 ">
                <h6 className="m-0">Total Services Price:</h6>

            <h6 className="fw-bold m-0">
                { `${Number(requestDetails.total_services_price)?.toLocaleString("en-US")} L.E`}
              </h6>
              </div>
              <div className="d-flex align-items-center justify-content-between py-2 ">
                <h6 className="fw-bold m-0">Customer Final Cost:</h6>

                <h6 className="fw-bold m-0">
                { `${Number(requestDetails.total_price)?.toLocaleString("en-US")} L.E`}

              </h6>
              </div>
              </div>}
                    
                    {isPending &&   
                    
                  <div className="row">
                    <div className="col-md-6 col-12">
                        <button disabled={services.some(s => !s.ui.isAccepted && !s.ui.isRejected)
                        } onClick={submitServices} className="w-100 btn btn-dark">
                          Send to user {acceptedCount} of {services.length} services

                        </button>
                    </div>
                    <div className="col-md-6 col-12">
                      <button onClick={saveDraft} className='w-100 btn btn-light fw-semibold'>Save as a draft</button>
                    </div>
                  </div>
                        
                        } 
              </div>
            )}

          
        </Box>
      </Drawer>
      
      <div className="m-4">
        {/* Header section */}
        <div className="">
          <h5 className="fw-semibold">
            User Requests - Other Services
          </h5>
        </div>
        <div className="d-flex align-items-center" style={{ width: "70%" }}>
          <div className="w-50 mt-1">
            <FormControl fullWidth variant="outlined" size="small">

              <OutlinedInput
                id="search-orders"
                placeholder='Search for orders ID, customer name, or date ...'
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                endAdornment={
                  <InputAdornment position="start">
                    <IconButton>
                      <Search />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </div>
          <div className="w-25 mb-2 mx-2 position-relative">
            <input
              type="date"
              className="date-input form-control"
              value={filterDate}
              onChange={(e) => {
                setFilterDate(e.target.value);
                setPage(0);
              }}
            />

            {filterDate && (
              <button
                type="button"
                className="btn btn-sm btn-light position-absolute"
                style={{
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  padding: "2px 6px",
                  fontSize: "12px",
                }}
                onClick={() => {
                  setFilterDate("");
                  setPage(0);
                }}
              >
                ✕
              </button>
            )}
          </div>


        </div>
        {/* tabs section */}
        <div
          className="tabs-section bg-light rounded-3 d-flex align-items-center my-3"
          style={{
            width: "fit-content",
            maxWidth: "100%",
            overflowX: "auto",
            whiteSpace: "nowrap",
            WebkitOverflowScrolling: "touch",
            height: "50px",
          }}
        >
          <Tabs
          
            value={selectedTab}
            onChange={(_, value) => setSelectedTab(value)}
          >
            <Tab  value="all" label={`All (${userRequests.length})`} />

            {requestStatuses.map((st) => (
              <Tab
               sx={{ textTransform: "capitalize" }}
                key={st.id}
                value={st.id}
                label={`${st.name} (${st.requests_count})`}
              />
            ))}
          </Tabs>


        </div>
        {/* table data */}
        <div className="my-3">
          {filteredRequests.length > 0 ? <div className="data-grid-small">
            <Paper sx={{ height: "auto", width: "100%" }}>
              <DataGrid
                rows={filteredRequests}
                columns={columns}
                initialState={{ pagination: { paginationModel } }}
                pageSizeOptions={[5, 10, 20, 50]}
                checkboxSelection
              
                sx={{ border: 0, overflow: "hidden" }}
                slotProps={{
                  pagination: {
                    sx: {
                      justifyContent: "center",
                      display: "flex",
                      alignItems: "center",

                    },
                  },
              
                }}
              
              />
            </Paper>

          </div> :
           <div className="flex flex-column text-center">

            <img src={noData} alt="no-data" />
            <p style={{ color: "#535353" }} className=''>No available user requests</p>
          </div>}



        </div>

      </div>

    </>


  )
}

export default OtherServices